import React, { useEffect, useRef, useState } from 'react'
import { ImageViewer, Image } from 'antd-mobile'
import moment from "moment";
import general from '../../general';

export default function GfyxItem(props) {

  const [trade,setTrade] = useState(props.children);
  const [visible, setVisible] = useState(false)
  const [imgs, setImgs] = useState([])
  const ref = useRef()

  useEffect(()=>{
    if (trade.game_own_screenshots.length > 2){
      setImgs(trade.game_own_screenshots.slice(0,3))
    }else {
      setImgs(trade.game_own_screenshots)
    }
  },[trade])

  useEffect(()=>{    
    setTrade(props.children)
  },[props.children])

  const handleTapImg = (index)=>{
    setVisible(true)
    ref.current.swipeTo(index)
  }

  return (
    <div className='gfyx-item' onClick={()=>{
      general.history.push('/trade/detail?id=' + trade.trade_id)
    }}>
      <div className="content">
        <div className="info">
          <div className='game-name'>
            <span className='name'>{trade.game_name}</span>
            <span className='nameRemark'>{trade.nameRemark}</span>
          </div>
          <div className="text">{trade.title}</div>
          <div className="text">区服：{trade.server_name}&nbsp;累充金额：{trade.total_amount}元</div>
        </div>
        <div className="price">{trade.trade_price}</div>
      </div>
      <div className="imgs">
        {imgs.map((item,index)=>{
          return <div key={index} className='img' onClick={e=>{
              e.preventDefault();
              e.stopPropagation();
              handleTapImg(index)}
            }>
            <Image placeholder={
              <img src='resources/placeholder/game-icon.png' alt="" />
            } key={index} src={item.thumb} alt="" />
          </div>
        })}
      </div>
      <div className="time">
        <span>上架时间:{moment(trade.sell_time * 1000).format('YYYY-MM-DD HH:mm:ss')}{props.showType}</span>
        {props.showType == true && <span className='type'>{(()=>{
          if (trade.trade_type == '-1'){
            return '已失效'
          }else if (trade.trade_type == '0'){
            return '待审核'
          }else if (trade.trade_type == '1'){
            return '已完成'
          }else if (trade.trade_type == '2'){
            return '被驳回'
          }else if (trade.trade_type == '3'){
            return '出售中'
          }
        })()}</span>}
      </div>
      <ImageViewer.Multi
        classNames='mask'
        getContainer={document.getElementById('root')}
        images={trade.game_own_screenshots?.map(e=>e.source)}
        visible={visible}
        defaultIndex={0}
        ref={ref}
        onClose={e => {
          setVisible(false)
        }}
      />
    </div>
  )
}
